module.exports = __webpack_public_path__ + "static/media/img-01.8a559058.jpg";